import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const UseTokenValidator = () => {
  const navigate = useNavigate();

  const isTokenExpired = (token) => {
    if (!token) return true;
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem('fullName');
    localStorage.removeItem('email');
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    localStorage.removeItem('profilePictureUrl');
 
    navigate('/login');
  }, [navigate]);

  const getTokenExpirationTime = (token) => {
    try {
      const decoded = jwtDecode(token);
      return decoded.exp;
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");

      if (token) {
        const expirationTime = getTokenExpirationTime(token);
        const currentTime = Date.now() / 1000;
        const timeRemaining = expirationTime - currentTime;

        if (timeRemaining <= 0) {
          handleLogout();
        } else {
          const timeToCheck = timeRemaining;

          if (timeToCheck > 0) {
            const timer = setTimeout(() => {
              if (isTokenExpired(token)) {
                handleLogout();
              }
            }, timeToCheck * 1000);
            return () => clearTimeout(timer);
          }
        }
      }
    };

    const interval = setInterval(checkTokenExpiration, 600000);

    checkTokenExpiration();

    return () => clearInterval(interval);
  }, [handleLogout]);

  return null;
};

export default UseTokenValidator;
